module.exports = "/assets/data/f4c3fda562399383ce679e24907dce85-MK16.data.json";